export default __webpack_public_path__ + "static/media/Landing_PageOff_White_Landing_Page.9a4ba5f8.svg";